import React from 'react'
import { systemContext } from './context';

const useSystem = () => {
  const {
    approaches,
    issues,
    organizationTypes,
    audiences,
    approachOptions,
    issueOptions,
    organizationTypeOptions,
    audienceOptions,
    categoryResourceOptions,
    categoryBlogOptions,
    typeResourceOptions,
    uppercasedAudienceOptions,
    uppercasedAudienceOptionsMap,
  } = React.useContext(systemContext);
  return {
    approaches,
    issues,
    organizationTypes,
    audiences,
    approachOptions,
    issueOptions,
    organizationTypeOptions,
    audienceOptions,
    categoryResourceOptions,
    categoryBlogOptions,
    typeResourceOptions,
    uppercasedAudienceOptions,
    uppercasedAudienceOptionsMap,
  };
}

export { useSystem }
